import {AmplitudeApartmentPricesButtonName, trackAmplitudeButtonClick} from "../../../tracking/amplitude/track_amplitude_button_click";
import {PRICES_HUB_ANALYTICS_LOCATION} from "./prices_hub_analytics";

interface ITrackPricesHubButtonClickParams {
    buttonName: AmplitudeApartmentPricesButtonName;
    /** Label exactly as the user sees it - a city name, a short title, or prev / next for arrows. */
    value: string;
    buttonLink?: string | null;
}

export const trackPricesHubButtonClick = (params: ITrackPricesHubButtonClickParams) => {
    trackAmplitudeButtonClick({
        buttonName: params.buttonName,
        buttonCategory: PRICES_HUB_ANALYTICS_LOCATION,
        itemId: null,
        buttonLink: params.buttonLink ?? null,
        value: params.value
    });
};
import {AmplitudeApartmentPricesButtonName, trackAmplitudeButtonClick} from "../../../tracking/amplitude/track_amplitude_button_click";
import {PRICES_HUB_ANALYTICS_LOCATION} from "./prices_hub_analytics";

interface ITrackPricesHubButtonClickParams {
    buttonName: AmplitudeApartmentPricesButtonName;
    /** Label exactly as the user sees it - a city name, a short title, or prev / next for arrows. */
    value: string;
    buttonLink?: string | null;
}

export const trackPricesHubButtonClick = (params: ITrackPricesHubButtonClickParams) => {
    trackAmplitudeButtonClick({
        buttonName: params.buttonName,
        buttonCategory: PRICES_HUB_ANALYTICS_LOCATION,
        itemId: null,
        buttonLink: params.buttonLink ?? null,
        value: params.value
    });
};
